import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"outlined":"","label":_vm.$t('Delivery Shipping Window'),"hide-details":"auto","type":"number"},model:{value:(_vm.requestedDeliveryWindow),callback:function ($$v) {_vm.requestedDeliveryWindow=_vm._n($$v)},expression:"requestedDeliveryWindow"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }